import { AppLayout } from "@app/layouts/app-layout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated")({
	component: () => <AppLayout />,
});
